export default "__VITE_ASSET__BzGjHn2$__"